// One status line at the bottom of the page; replaces alert/confirm. GPL-3.0-or-later.
import { t } from "../i18n/index.js";

let timer = 0;
/** Show `msg` (HTML from the app, never raw user text). With `undo`, an Undo button. */
export function toast(msg: string, undo?: () => void) {
  let el = document.getElementById("toast");
  if (!el) { el = document.createElement("div"); el.id = "toast"; el.setAttribute("role", "status"); el.setAttribute("aria-live", "polite"); document.body.appendChild(el); }
  el.hidden = false;
  el.innerHTML = `<span>${msg}</span>` + (undo ? `<button class="btn small" id="toast-undo">${t("Undo")}</button>` : "");
  if (undo) document.getElementById("toast-undo")!.addEventListener("click", () => { undo(); el!.hidden = true; });
  clearTimeout(timer); timer = window.setTimeout(() => (el!.hidden = true), undo ? 6000 : 3500);
}
